import { connect, MapDispatchToProps } from 'react-redux';
import { pushUserSymbolsPopup } from '../../../UserSymbolsPopup/actions';
import { Props } from './UserSymbol';

type DispatchProps = Pick<Props, 'pushUserSymbolsPopup'>;

type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  pushUserSymbolsPopup,
};

export default connect(undefined, mapDispatchToProps);
